import * as React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom"; // أضفنا useLocation
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import { fetchDailyPlan } from "./services/authServices/getSetionService";
import { Box, CircularProgress } from "@mui/material";
import SplashScreen from "./pages/SplashScreen";

// استيراد الشريط العلوي
import TopBar from "./utils/TopBar"; 

export default function App() {
  const dispatch = useDispatch();
  const location = useLocation(); // لمعرفة المسار الحالي

  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );

  const [isInitializing, setIsInitializing] = useState(true);
  const sessionStatus = useSelector((state) => state.session?.loading);

  useEffect(() => {
    const initApp = async () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      const sessionHash = localStorage.getItem("sessionHash");

      if (loggedIn && sessionHash) {
        try {
          await dispatch(fetchDailyPlan(sessionHash)).unwrap();
        } catch (error) {
          console.error("Failed to restore session on reload:", error);
        }
      }
      setIsInitializing(false);
    };

    initApp();
  }, [dispatch]);

  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  if (isInitializing || sessionStatus) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: 'background.default' // لضمان لون الشاشة أثناء التحميل
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // التحكم في إظهار الشريط العلوي (لا نظهره في صفحة تسجيل الدخول)
  // التحكم في إظهار الشريط العلوي (نخفيه في صفحة الدخول وصفحة الـ splash)
  const showTopBar = isAuthenticated && location.pathname !== "/login" && location.pathname !== "/splash";

  return (
    // هذه الحاوية ضرورية جداً لكي يأخذ التطبيق بالكامل لون الخلفية (فاتح/داكن)
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundColor: 'background.default', // يتغير تلقائياً مع الثيم
      color: 'text.primary',
      transition: 'background-color 0.3s ease' // انتقال ناعم عند تبديل الثيم
    }}>
      
      {/* عرض الشريط العلوي فقط للمستخدم المسجل وفي غير صفحة الدخول */}
      {showTopBar && <TopBar />}

      {/* حاوية محتوى الصفحات */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <Routes>
          <Route
            path="/login"
            element={<LoginPage setIsAuthenticated={setIsAuthenticated} />}
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/splash"
            element={
              <ProtectedRoute>
                <SplashScreen/>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
    </Box>
  );
}